import React from "react";
import { Dialog, DialogContent, CircularProgress, Typography } from "@mui/material";

const LoadingDialog = ({ open, message = "Loading..." }) => {
  return (
    <Dialog closeAfterTransition={false} open={open} PaperProps={{ style: { textAlign: "center" } }} maxWidth="xs">
      <DialogContent>
        <CircularProgress />
        <Typography variant="body1" style={{ marginTop: "16px" }}>
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default LoadingDialog;